import { actions as notifications } from '@saucelabs/sl-container-notifications';
import { createApiAction } from '@saucelabs/sl-util-redux';

import types from './types';

const performBiometricAuthentication = createApiAction(
  types.MOBILE_DEVICE_BIOMETRIC_AUTHENTICATION,
  (payload, meta, dispatch, getState) => {
    const device = getState().apps.manual.session.get('device');
    const { match } = payload;

    // Please note the ...Biometrics... plural in web-rdc-client
    return device.performBiometricsAuthentication(match).then((response) => {
      // TODO: Let request errors fail in `web-rdc-client` to enable handling server errors.
      // Right now the response only has a mesage when the request fails (i.e. 500 status).
      if (response.message) {
        return dispatch(notifications.notifyWarning('A biometric authentication reponse has been sent but could not be handled properly. Make sure your app is open.'));
      }
      return dispatch(notifications.notifySuccess(`A ${match ? 'successful' : 'failed'} biometric authentication response has been sent to your app.`));
    });
  },
);

export default {
  performBiometricAuthentication,
};
